import { ref } from 'vue'

import { closeSetupDrawer } from '@/components/setup/setupDrawerOpen'

// Module scope, not component state: the setup surfaces that ask for the panel are
// nowhere near the widget that owns it. A request count rather than a flag, because
// the panel's real open state is the vuex mode and a second one would drift from it.
// Only the namespace a merchant is actually shown is mounted, so only that one hears
// this.
const openRequests = ref(0)

// Set alongside the request rather than passed through it, so the widget picks it
// up from the same watcher that opens the panel.
let pendingPrompt = ''

// The drawer and the panel are both right-hand panels and the panel outranks the
// drawer on z-index, so leaving the drawer open would bury it with no way back.
export function openBotWidget({ prompt } = {}) {
  closeSetupDrawer()
  pendingPrompt = typeof prompt === 'string' ? prompt.trim() : ''
  openRequests.value += 1
}

// Taken rather than read: the widget is opened from several places, and a prompt
// left behind would be sent again the next time one of them asked for the panel.
export function takeBotWidgetPrompt() {
  const prompt = pendingPrompt
  pendingPrompt = ''
  return prompt
}

export function useBotWidgetOpen() {
  return { openRequests, open: openBotWidget, takePrompt: takeBotWidgetPrompt }
}
